export default __webpack_public_path__ + "static/media/element_91.33055ad3.webp";